import {
    WS_PREPLAY_START_ACTION,
    WS_PREPLAY_OFF_ACTION,
    WS_PREPLAY_UPDATE_ACTION,
} from './preplay';
import { getWsInterface, WS_CONNECTION_NAME, UNNAMED_WS_HANDLER_COMPONENT } from '../../spa/Utils/Websockets';
export const WS_EVENT_START_ACTION = WS_PREPLAY_START_ACTION;
export const WS_EVENT_OFF_ACTION = WS_PREPLAY_OFF_ACTION;
export const WS_EVENT_UPDATE_ACTION = WS_PREPLAY_UPDATE_ACTION;
export const WS_EVENT_INPLAY_UPDATE_ACTION = 'inplay_update';

export class MainSocket {

    constructor(wsInterface) {
        this.wsConectionName = WS_CONNECTION_NAME;
        this.wsEventUpdateHandler = this.wsEventUpdateHandler.bind(this);
        this.isWsEventHandlersSet = false;
        this.isWsInplayEventHandlersSet = false;
        this.wsEventUpdateListeners = new Set();
        this.wsInterface = wsInterface;
        this.removeHandlerCallbacks = [];
    }

    /**
     * The ws event update handler
     * @param  {Array} args The arguments passed from the websocket
     * @return {void}
     */
    wsEventUpdateHandler(...args) {
        this.wsEventUpdateListeners.forEach(listener => {
            listener(...args);
        });
    }

    /**
     * Removes all JS message handlers that were registered under a name.
     * @param {String} componentName the component name that the handlers were registered under
     * @returns {Boolean} was a handler removed?
     */
    removeWsEventHandlers(componentName) {
        if (this.removeHandlerCallbacks[componentName] && this.removeHandlerCallbacks[componentName].length) {
            this.removeHandlerCallbacks[componentName].forEach(cb => cb());
        }
    }

    /**
     * A helper to set the ws handlers
     * @param {String} [componentName=UNNAMED_WS_HANDLER_COMPONENT] A slug for the component to track callback functions (must be unique per page)
     * @return {void}
     */
    setWsEventHandlers(componentName = UNNAMED_WS_HANDLER_COMPONENT) {
        if (!this.removeHandlerCallbacks[componentName]) {
            this.removeHandlerCallbacks[componentName] = [];
        }
        const removeHandlerCallbacks = this.removeHandlerCallbacks[componentName];
        /**
         * @todo AM-2540 tidy and refactor to use ().forEach()
         */
        removeHandlerCallbacks.push(this.wsInterface.requestHandler(this.wsConectionName).registerHandler(WS_EVENT_START_ACTION, this.wsEventUpdateHandler, componentName));
        removeHandlerCallbacks.push(this.wsInterface.requestHandler(this.wsConectionName).registerHandler(WS_EVENT_OFF_ACTION, this.wsEventUpdateHandler, componentName));
        removeHandlerCallbacks.push(this.wsInterface.requestHandler(this.wsConectionName).registerHandler(WS_EVENT_UPDATE_ACTION, this.wsEventUpdateHandler, componentName));
        removeHandlerCallbacks.push(this.wsInterface.requestHandler(this.wsConectionName).registerHandler(WS_EVENT_INPLAY_UPDATE_ACTION, this.wsEventUpdateHandler, componentName));

        this.isWsEventHandlersSet = true;

        return () => this.removeWsEventHandlers(componentName);
    }

    /**
     * A helper to set the ws inplay handlers
     * @todo AM-2540 can we remove this and just use the one registerHandler? Who's calling this? Deprecate?
     * @deprecated - just use setWsEventHandlers()
     * @param {String} [componentName=UNNAMED_WS_HANDLER_COMPONENT] A slug for the component to track callback functions (must be unique per page)
     * @return {void}
     */
    setWsInplayEventHandlers(componentName = UNNAMED_WS_HANDLER_COMPONENT) {
        this.wsInterface.requestHandler(this.wsConectionName).registerHandler(WS_EVENT_START_ACTION, this.wsEventUpdateHandler, componentName);
        this.wsInterface.requestHandler(this.wsConectionName).registerHandler(WS_EVENT_OFF_ACTION, this.wsEventUpdateHandler, componentName);
        this.wsInterface.requestHandler(this.wsConectionName).registerHandler(WS_EVENT_UPDATE_ACTION, this.wsEventUpdateHandler, componentName);
        this.wsInterface.requestHandler(this.wsConectionName).registerHandler(WS_EVENT_INPLAY_UPDATE_ACTION, this.wsEventUpdateHandler, componentName);

        this.isWsInplayEventHandlersSet = true;
    }

    /**
     * Starts listening for ws updates
     * @param {Array} subscriptionData array of [{event_id: 1, market_id:1, selection_id:1}, {event_id: 2, market_id:2, selection_id:2}]
     * @param {String} [componentName=UNNAMED_WS_HANDLER_COMPONENT] A slug for the component to track callback functions (must be unique per page)
     * @return {void}
     */
    subscribeForUpdates(subscriptionData, componentName = UNNAMED_WS_HANDLER_COMPONENT) {
        this.wsInterface.requestHandler(this.wsConectionName).subscribe(subscriptionData);

        if (!this.isWsEventHandlersSet) {
            this.wsInterface.onCloseConnections(() => {
                this.isWsEventHandlersSet = false;
                this.isWsInplayEventHandlersSet = false;
                this.wsEventUpdateListeners = new Set();
            });

            this.setWsEventHandlers(componentName);
        }
    }

    /**
     * Stops listening for ws updates
     * @param {Array} unSubscriptionData array of {event_id: 1, markets: [{id: 1, selections: [3, 4]}]}
     * @return {void}
     */
    unsubscribeForUpdates(unSubscriptionData) {
        this.wsInterface.requestHandler(this.wsConectionName).unsubscribe(unSubscriptionData);
    }

    /**
     * Handle on ws event update
     * @param  {Function} callback A callback that is called with the started event
     * @return {Function} A callback to unsubscribe from the event
     */
    onWsEventUpdate(callback) {
        this.wsEventUpdateListeners.add(callback);
        const wsListeners = this.wsEventUpdateListeners;

        return function unsubscribe() {
            wsListeners.delete(callback);
        };
    }

    /**
     * Creates ws listening for updates
     * @param {object} betCards betcards object
     * @return {void}
     */
    startListeningForUpdates (betCards) {
        this.subscribeForUpdates(
            this.getSubscriptionData(betCards)
        );
    }

    /**
     * Stops ws listening for updates
     * @param {object} betCards betcards object
     * @return {void}
     */
    stopListeningForUpdates (betCards) {
        this.unsubscribeForUpdates(
            this.getSubscriptionData(betCards)
        );
    }

    /**
     * Returns the data to listen for selection updates
     * @param {object} betCards object
     * @return {Array} The selections subscription data
     */
    getSubscriptionData(betCards) {
        let selectionsToSubscribe = [];
        betCards.map(pointer => pointer.selection_pointers.map(sel => selectionsToSubscribe.push(sel)));

        return selectionsToSubscribe;
    }
}

const wsInterface = getWsInterface();
const mainSocket = new MainSocket(wsInterface);
export default mainSocket;
